/* MAISON KIYAN — global.js */
(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = document.getElementById(btn.getAttribute('data-drawer-open'));
      if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var drawer = el.closest('.drawer');
      if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });

  /* ---------- Header search toggle ---------- */
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var bar = document.getElementById('HeaderSearch');
      if (!bar) return;
      bar.classList.toggle('is-open');
      if (bar.classList.contains('is-open')) {
        var input = bar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.getAttribute('data-src');
        if (thumb.getAttribute('data-srcset')) main.srcset = thumb.getAttribute('data-srcset');
        main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : main.alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Quantity buttons ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (btn.getAttribute('data-action') === 'plus') val++;
        else val = Math.max(1, val - 1);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (container) {
    var dataEl = container.querySelector('[data-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = container.querySelectorAll('[data-option-select]');
    var idInput = container.querySelector('input[name="id"]');
    var priceEl = container.querySelector('[data-price]');
    var compareEl = container.querySelector('[data-compare-price]');
    var atcBtn = container.querySelector('[data-atc]');
    var moneyFormat = container.getAttribute('data-money-format') || '{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', '.');
      var withApostrophe = amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
      return moneyFormat
        .replace('{{amount}}', withApostrophe)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }

    function currentOptions() {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    }

    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = atcBtn.getAttribute('data-text-unavailable') || 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (atcBtn) {
        if (match.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = atcBtn.getAttribute('data-text-add') || 'In den Warenkorb';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = atcBtn.getAttribute('data-text-soldout') || 'Ausverkauft';
        }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* ---------- Sticky add to cart ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
    var stickyBtn = sticky.querySelector('button');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { anchor.click(); });
    }
  }

  /* ---------- Collection filters auto submit ---------- */
  var facetsForm = document.getElementById('FacetsForm');
  if (facetsForm) {
    facetsForm.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () { facetsForm.submit(); });
    });
    var sortSelect = facetsForm.querySelector('[data-sort-select]');
    if (sortSelect) sortSelect.addEventListener('change', function () { facetsForm.submit(); });
  }
})();
